import React from 'react';
import PropTypes from 'prop-types';

function ErrorBanner({ error }) {
	if (!navigator.onLine) {
		return (
			<div className="pet-picker__list__error-banner pet-picker__list__error-banner--warn">
				<div className="pet-picker__list__error-banner__heading">
					You’re in offline mode.
				</div>
				Your pets might not be up to date and purchases won’t work until you’re back online.
			</div>
		);
	}

	if (error) {
		return (
			<div className="pet-picker__list__error-banner pet-picker__list__error-banner--error">
				<div className="pet-picker__list__error-banner__heading">
					Sorry, there was a problem getting your pets.
				</div>
				Purchases may not work right now. To fix this issue, try refreshing the page.<br />If you keep having this problem, email meow@tabbycats.club
				{error.response && ` with code: ${error.response.errorType}`}.
			</div>
		);
	}

	return null;
}

ErrorBanner.propTypes = {
	error: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),
};

ErrorBanner.defaultProps = {
	error: undefined,
};

export default ErrorBanner;



// WEBPACK FOOTER //
// ./src/components/Extension/PetPicker/ErrorBanner.js